if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.input.min = min;

        if (max) {
          this.input.max = max;
        } else {
          this.input.removeAttribute('max');
        }
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

class ProductCountDown extends HTMLElement {
  constructor() {
    super()
    this.date = this.getAttribute('date')
    this.productId = this.getAttribute('data-product-id')
    this.dataJetId = this.getAttribute('data-datajet-id') || window.dataJetId || window.DATAJET_ID
    this.daysElement = this.querySelector('#countdown-days')
    this.hoursElement = this.querySelector('#countdown-hours')
    this.minutesElement = this.querySelector('#countdown-minutes')
    this.secondsElement = this.querySelector('#countdown-seconds')
    this.dateElement = this.querySelector('.countdown-date')
    this.updateCountDown = this.updateCountDown.bind(this);
    this.interval = null
    this.hasNotifiedDataJet = false
    this.countdownCompleted = false
  }

  connectedCallback() {
    this.updateCountDown()
    this.interval = setInterval(this.updateCountDown, 1000);
  }

  async updateCountDown() {
    if (this.countdownCompleted) return;

    const DateTime = luxon.DateTime;
    if (typeof DateTime === 'function') {
      const dateString = this.getAttribute('data-release-date');
      if (dateString && dateString !== '') {
        const dateTime = DateTime.fromISO(dateString, {setZone: true});
        const localDateTime = dateTime.toLocal();
        const luxonNow = DateTime.now();
        const diff = localDateTime.diff(luxonNow);
        if (diff.toMillis() <= 0) {
          this.countdownCompleted = true
          clearInterval(this.interval);
          this.interval = null
          this.classList.add('hide');
          document.querySelector('.rarity-block').classList.remove('rarity-block--margin-top');
          await this.handleCountdownComplete();
          return;
        }
        else {
          const day = localDateTime.toFormat('d');
          const month = localDateTime.toFormat('MMMM');
          
          function getOrdinalSuffix(day) {
            if (day > 3 && day < 21) return "th";
            switch (day % 10) {
              case 1:
                return "st";
              case 2:
                return "nd";
              case 3:
                return "rd";
              default:
                return "th";
            }
          }
          
          this.dateElement.innerText = `${day}${getOrdinalSuffix(day)} ${month}`;
          
          const shiftedDiff = diff.shiftTo('days', 'hours', 'minutes', 'seconds');
          const days = Math.floor(shiftedDiff.days);
          const hours = Math.floor(shiftedDiff.hours);
          const minutes = Math.floor(shiftedDiff.minutes);
          const seconds = Math.floor(shiftedDiff.seconds);

          this.daysElement.innerText = `${days}d`
          this.hoursElement.innerText = `${hours}h`
          this.minutesElement.innerText = `${minutes}m`
          this.secondsElement.innerText = `${seconds}s`
        }
      }
    } else {
      const targetDate = new Date(this.date).getTime();
      const now = new Date().getTime();
      const difference = targetDate - now;
      
      if (difference < 0) {
        this.countdownCompleted = true;
        this.style.display = 'none';
        clearInterval(this.interval);
        this.interval = null
        this.classList.add('hide')
        document.querySelector('.rarity-block').classList.remove('rarity-block--margin-top')
        await this.handleCountdownComplete();
        return;
      } else {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        
        this.daysElement.innerText = `${days}d`
        this.hoursElement.innerText = `${hours}h`
        this.minutesElement.innerText = `${minutes}m`
        this.secondsElement.innerText = `${seconds}s`
      }
    }
  }

  async handleCountdownComplete() {
    if (this.hasNotifiedDataJet) {
      this.style.display = 'none';
      setTimeout(() => {
        window.location.reload();
      }, 3000);
      return
    }

    this.hasNotifiedDataJet = true

    if (this.dataJetId && this.productId) {
      try {
        const res = await fetch(`/apps/datajet/task/${this.dataJetId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            product_id: this.productId,
          }),
        })

        if (!res.ok) {
          console.error('Datajet request failed:', res.status, await res.text())
        } else {
          console.log('✅ Datajet notified for product', this.productId)
        }
      } catch (err) {
        console.error('Datajet request error:', err)
      }
    } else {
      console.warn('Missing dataJetId or productId; skipping Datajet request')
    }

    this.style.display = 'none';
    window.location.reload()
  }
}

class WishlistBlock extends HTMLElement {
  constructor(){
    super()
    this.productId = this.getAttribute('product-id')
  }

  connectedCallback() {
    const onSwymLoadCallback = (_swat) => {
      if (_swat) {
        console.log("Swym scripts tags are installed on your store");
        this.updateCounts(_swat)
      }
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(onSwymLoadCallback);
    this.updateCounts(_swat)
  }
  
  updateCounts(swat) {
    const countsElement = this.querySelector('#wishlist-counts')
    const product = {
      empi: this.productId
    };
    
    const onSuccess = function(data) {
      console.log("Successfully fetched social count data of the product: ", data);
      countsElement.innerText = data.data.count
    }
    
    const onError = function(error) {
      console.log("Error while fetching social count", error);
    }
    
    swat.wishlist.getSocialCount(product, onSuccess, onError);
  }
}

customElements.define('wihslist-block', WishlistBlock)
customElements.define('count-down', ProductCountDown)
